module.exports = __webpack_public_path__ + "static/media/PB_Y_14.f3445604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_14.png
// module id = 243
// module chunks = 0